module.exports = __webpack_public_path__ + "img/christophlogo.f3532ba8.png";